<div class="load__animation" *ngIf="showAnimation$ | async">
  <img src="assets/animations/animation-load.svg" alt="" />
</div>
<div class="login-page" *ngIf="!(showAnimation$ | async)">
  <div class="login-page__image"></div>
  <div class="login-page__form">
    <div class="form-container" (keyup.enter)="signin()" [formGroup]="authForm" [@errorFormAnimation]="authError">
      <div class="logo-section">
        <div class="logo"></div>
        <div class="sub-logo">{{ 'SERVICE_PORTAL' | translate }}</div>
      </div>

      <div class="header-section" *ngIf="authMethod!=='NIAS'">
        {{ 'SIGN_IN' | translate }}
      </div>

      <div class="inputs-section" *ngIf="authMethod!=='NIAS'">
        <div class="login">
          <app-input
            formControlName="login"
            [control]="login"
            [isInvalid]="!!login.errors && !login.pristine"
            [label]="'LOGIN_LABEL' | translate"
            [isServerError]="isServerError"
            [placeholder]="'LOGIN_PLACEHOLDER' | translate"
          >
          </app-input>
        </div>
        <div class="password">
          <app-input
            formControlName="password"
            [control]="password"
            [label]="'PASSWORD_LABEL' | translate"
            [type]="'password'"
            [isInvalid]="!!password.errors && !password.pristine"
            [isPassword]="true"
            [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
          >
          </app-input>
        </div>
      </div>

      <div class="links-section" *ngIf="authMethod!=='NIAS'">
        <a class="request-access" *ngIf="showRequestAccessPage" routerLink="/requestaccess">{{ 'REQUEST_ACCESS' | translate }}</a>
        <a class="forgot-password" routerLink="/forgotpassword">{{ 'FORGOT_PASSWORD' | translate }}</a>
      </div>

      <div class="checkbox-section" *ngIf="authMethod!=='NIAS'">
        <app-checkbox formControlName="keepSignedIn"></app-checkbox>
        <div class="label">{{ 'KEEP_ME_SIGNED_IN' | translate }}</div>
      </div>

      <div class="button-section" *ngIf="authMethod!=='NIAS'">
        <app-button
          (triggered)="signin()"
          *ngIf="!(authLoading$ | async)"
          [size]="'large'"
          [filled]="true"
          [disabled]="authForm.invalid"
        >
          {{ 'LOG_IN' | translate }}
        </app-button>

        <div class="load__animation" *ngIf="authLoading$ | async">
          <img src="assets/animations/animation-load.svg" alt="" />
        </div>
      </div>
      <div class="button-section" *ngIf="authMethod=='NIAS'">
        <app-button
          (triggered)="signinNias()"
          [size]="'large'"
          [filled]="true"
        >
          {{ 'LOG_IN_WITH_NIAS' | translate }}
        </app-button>
        <div class="load__animation" *ngIf="authLoading$ | async">
          <img src="assets/animations/animation-load.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="version">v{{ appVersion }}</div>
  </div>
</div>
